import { Component, Vue } from "vue-property-decorator"
import { CheckstandData } from '@/types/views/checkstand.interface'
import signUp from '@/api/signUp'
import app from '@/api/app'
import baseUrl from '../../utils/alipayUrl'
import {getNavigationHeight} from "@/utils/common";
// import {  } from "@/components" // 组件

@Component({})
export default class Checkstand extends Vue {

  // data
  private pageName = 'checkstand'
  private checkedId: string = "1"
  private orderId: any = ""
  private checkObj: any
  private detailInfo: any = {
    payAmount: '',
    promotionName: '',
    count: '',
    price: ''
  }
  private id: any = ""
  private model: boolean = false
  private tradeNo: string = ""
  private authCode = localStorage.getItem("authCode")

  private list: any = [{
    id: "1",
    name: "支付宝",
    pic: require("../../assets/images/alipay.png"),
  }
    // , {
    //   id: "2",
    //   name: "微信",
    //   pic: require("../../assets/images/wechatpay.png"),
    // }
    // , {
    //   id: "3",
    //   name: "银联支付",
    //   pic: require("../../assets/images/bank.png"),
    // }
  ]
  private headerHeight: string = '0'
created(){

}
  mounted() {
    this.headerHeight = getNavigationHeight()
    this.id = this.$route.query.id;
    this.checkObj = this.$route.query.checkObj
    this.orderId = this.$route.query.orderId
    this.orderDetail()

  }



  // 初始化函数
  init() {
    this.$router.push({ name: 'signUp', query: { id: this.id, checkObj: this.checkObj } });
  }

  check(id: string) {
    this.checkedId = id
  }

  orderDetail() {
    let params = {
      orderId: this.orderId
    }

    signUp.orderDetail(params).then(res => {
      if (res.returnCode === "0") {
        this.detailInfo = res.data
      } else {
        this.$toast.fail('res.returnMsg')
      }
    });
  }
// 确认支付
  confim() {
    if (this.checkedId == "") {
      this.$toast.fail('请先选中支付方式')
      return
    }
    if(this.checkedId === '1'){
      // console.log('支付宝支付1',this.orderId)
      window.location.href ="alipays://platformapi/startapp?appId=20000067&url=" + encodeURIComponent(`${baseUrl}/#/order/alipayBackPage?orderId=${this.orderId}&payType=${this.checkedId}&token=${localStorage.getItem("token")}&type=2`)
      setTimeout(()=>{
        this.model =true
      },2000)
    }else if(this.checkedId === '2') {
      console.log('微信支付')
    }

    //   let params = {
    //     orderId: this.orderId,
    //     payType: this.checkedId,
    //     authCode:this.authCode
    //   }
    // signUp.orderPay(params).then(res => {
    //   if (res.returnCode === "0") {
    //     this.tradeNo = res.data.tradeNo
    //     this.model = true
    //     app.payByUrl(res.data.payUrl)
    //     // if (this.total == 0.00) {
    //     //   this.$router.push({ name: 'showResult', params: { flag: "0" } });
    //     // } else {
    //     //   this.$router.push({ name: 'checkstand', params: { id: this.id, checkObj: this.checkObj } });
    //     // }
    //   } else {
    //     this.$toast.fail('res.returnMsg')
    //   }
    // });
  }

  // oderPayFun(params: any) {
  //   signUp.orderPay(params).then(res => {
  //     if (res.returnCode === "0") {
  //       this.tradeNo = res.data.tradeNo
  //       this.model = true
  //       // app.payByUrl(res.data.payUrl)
  //       // if (this.total == 0.00) {
  //       //   this.$router.push({ name: 'showResult', params: { flag: "0" } });
  //       // } else {
  //       //   this.$router.push({ name: 'checkstand', params: { id: this.id, checkObj: this.checkObj } });
  //       // }
  //     } else {
  //       this.$toast.fail('res.returnMsg')
  //     }
  //   })
  // }

// 暂不支付
  payStateNo(){
    this.model = false
    this.$router.push({ name: 'more', query: { communityId: localStorage.getItem("communityId"), launchArea:localStorage.getItem("launchArea"),cityCode:localStorage.getItem("cityCode"),token: localStorage.getItem("token") ,} })
  }
  //查询支付状态
  payState() {
    let params = {
      // tradeNo: this.tradeNo
      tradeNo: this.orderId
    }

    signUp.payState(params).then(res => {
      if (res.returnCode === "0") {
        //支付成功
        if (res.data.payState == '3') {
          this.$router.push({ name: 'showResult', query: { flag: "0" } });
          //支付失败
        } else if (res.data.payState == '5') {
          this.$router.push({ name: 'showResult', query: { flag: "1", message: '交易失败' } });
          //未支付
        } else if (res.data.payState == '1') {
          this.$toast.fail("未支付，请完成支付")
          this.model = false
          //支付中
        } else if (res.data.payState == '2') {
          // this.$toast.fail("正在支付中")
          this.$router.push({ name: 'showResult', query: { flag: "1", message: '交易失败' } });
          // this.model = false
        }
        // if (res.data.payState == '3') {
        //   //支付成功
        //   this.$router.push({ name: 'showResult', query: { flag: "0" } });
        //   //支付失败
        // } else {
        //   this.$router.push({ name: 'showResult', query: { flag: "1", message: '交易失败' } });
        //   //未支付
        // }
      } else {
        this.$toast.fail('res.returnMsg')
      }
    }).catch(e=>{
      this.$router.push({ name: 'showResult', query: { flag: "1", message: '交易失败' } });
    });

  }

}
